import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const alternativeArticles = articles.filter((a) => a.category === 'alternatives');

export default function AlternativeSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            安全可靠的替代方案
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            不必冒着安全风险使用破解版——这些优秀的正版应用同样经济实惠
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
          {alternativeArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-white rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-48 h-40 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5 flex flex-col justify-center">
                <span className="text-xs text-primary-500 font-medium mb-2 whitespace-nowrap">
                  <i className="ri-swap-line mr-1"></i>替代方案
                </span>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/category/alternatives"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-lg font-medium text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部替代方案
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}